[
  {
    "display": "true",
    "ui_columnname": "Event Type",
    "db_columnname": "Event Type",
    "datatype": "String",
    "mappingkey": "EventType",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Trade Date Time",
    "db_columnname": "Trade Date Time",
    "datatype": "String",
    "mappingkey": "TradeDateTime",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Trade ID",
    "db_columnname": "Trade ID",
    "datatype": "String",
    "mappingkey": "TradeID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "OMS Order ID",
    "db_columnname": "OMS Order ID",
    "datatype": "String",
    "mappingkey": "OMSOrderId",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Order ID",
    "db_columnname": "Order ID",
    "datatype": "String",
    "mappingkey": "OrderID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Act Ref Num",
    "db_columnname": "Act Ref Num",
    "datatype": "String",
    "mappingkey": "ActRefNum",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Symbol",
    "db_columnname": "Symbol",
    "datatype": "String",
    "mappingkey": "Symbol",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Side",
    "db_columnname": "Side",
    "datatype": "String",
    "mappingkey": "BuySellCode",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "TrdQty",
    "db_columnname": "TrdQty",
    "datatype": "String",
    "mappingkey": "Quantity",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Leaves Qty",
    "db_columnname": "Leaves Qty",
    "datatype": "String",
    "mappingkey": "LeavesQty",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Trd Price",
    "db_columnname": "Trd Price",
    "datatype": "String",
    "mappingkey": "Price",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Last Sale Price",
    "db_columnname": "Last Sale Price",
    "datatype": "String",
    "mappingkey": "LastSalePrice",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Capacity",
    "db_columnname": "Capacity",
    "datatype": "String",
    "mappingkey": "Capacity",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Execution Venue",
    "db_columnname": "Execution Venue",
    "datatype": "String",
    "mappingkey": "ExecutionVenue",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Bid Price",
    "db_columnname": "Bid Price",
    "datatype": "String",
    "mappingkey": "BidPrice",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Ask Price",
    "db_columnname": "Ask Price",
    "datatype": "String",
    "mappingkey": "AskPrice",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Contra Broker MPID",
    "db_columnname": "Contra Broker MPID",
    "datatype": "String",
    "mappingkey": "ContraBrokerMPID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Tick Test",
    "db_columnname": "Tick Test",
    "datatype": "String",
    "mappingkey": "TickTest",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Tick Direction",
    "db_columnname": "Tick Direction",
    "datatype": "String",
    "mappingkey": "TickDirection",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Trade Report",
    "db_columnname": "Trade Report",
    "datatype": "String",
    "mappingkey": "TradeReport",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Trade Modifier",
    "db_columnname": "Trade Modifier",
    "datatype": "String",
    "mappingkey": "TradeModifier",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "As Of",
    "db_columnname": "As Of",
    "datatype": "String",
    "mappingkey": "AsOf",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "As Of Date Time",
    "db_columnname": "As Of Date Time",
    "datatype": "String",
    "mappingkey": "AsOfDateTime",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Late Trade",
    "db_columnname": "Late Trade",
    "datatype": "String",
    "mappingkey": "LateTrade",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "PRP Date Time",
    "db_columnname": "PRP Date Time",
    "datatype": "String",
    "mappingkey": "PRPDateTime",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Trade Thru",
    "db_columnname": "Trade Thru",
    "datatype": "String",
    "mappingkey": "TradeThru",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Position",
    "db_columnname": "Position",
    "datatype": "String",
    "mappingkey": "Position",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Liquidity Flag",
    "db_columnname": "Liquidity Flag",
    "datatype": "String",
    "mappingkey": "LiquidityFlag",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Negotiated Trade",
    "db_columnname": "Negotiated Trade",
    "datatype": "String",
    "mappingkey": "NegotiatedTrade",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Locate Info",
    "db_columnname": "Locate Info",
    "datatype": "String",
    "mappingkey": "LocateInfo",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Acct type",
    "db_columnname": "AcctType",
    "datatype": "String",
    "mappingkey": "AcctType",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Trader Account",
    "db_columnname": "Trader Account",
    "datatype": "String",
    "mappingkey": "TraderAccount",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Cst Branch",
    "db_columnname": "Cst Branch",
    "datatype": "String",
    "mappingkey": "CstBranch",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Cust Rep",
    "db_columnname": "Cust Rep",
    "datatype": "String",
    "mappingkey": "CustRep",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "ISO Num",
    "db_columnname": "ISO Num",
    "datatype": "String",
    "mappingkey": "ISONum",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Barrier ID",
    "db_columnname": "Barrier ID",
    "datatype": "String",
    "mappingkey": "BarrierID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Branch Seq Num",
    "db_columnname": "Branch Seq Num",
    "datatype": "String",
    "mappingkey": "BranchSeqNum",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Cross Trade RefNum",
    "db_columnname": "Cross Trade RefNum",
    "datatype": "String",
    "mappingkey": "CrossTradeRefNum",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Contra Acct",
    "db_columnname": "Contra Acct",
    "datatype": "String",
    "mappingkey": "ContraAcct",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Settle Date",
    "db_columnname": "Settle Date",
    "datatype": "String",
    "mappingkey": "SettleDate",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Execution type",
    "db_columnname": "ExecutionType",
    "datatype": "String",
    "mappingkey": "ExecutionType",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Delivery Instructions",
    "db_columnname": "Delivery Instructions",
    "datatype": "String",
    "mappingkey": "DeliveryInstructions",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Exchange Trade Ref Num",
    "db_columnname": "Exchange Trade Ref Num",
    "datatype": "String",
    "mappingkey": "ExchangeTradeRefNum",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Ext Branch Seq Num",
    "db_columnname": "Ext Branch Seq Num",
    "datatype": "String",
    "mappingkey": "ExtBranchSeqNum",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Ext Order Ref Num",
    "db_columnname": "Ext Order Ref Num",
    "datatype": "String",
    "mappingkey": "ExtOrderRefNum",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Clearing Broker MPID",
    "db_columnname": "Clearing Broker MPID",
    "datatype": "String",
    "mappingkey": "ClearingBrokerMPID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Give Up Broker MPID",
    "db_columnname": "Give Up Broker MPID",
    "datatype": "String",
    "mappingkey": "GiveUpBrokerMPID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Order Desk",
    "db_columnname": "Order Desk",
    "datatype": "String",
    "mappingkey": "OrderDesk",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "OE Type",
    "db_columnname": "OE Type",
    "datatype": "String",
    "mappingkey": "OEType",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Terminal User",
    "db_columnname": "Terminal User",
    "datatype": "String",
    "mappingkey": "TerminalUser",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Bid Size",
    "db_columnname": "Bid Size",
    "datatype": "String",
    "mappingkey": "BidSize",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Ask Size",
    "db_columnname": "Ask Size",
    "datatype": "String",
    "mappingkey": "AskSize",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Market Seq Num",
    "db_columnname": "Market Seq Num",
    "datatype": "String",
    "mappingkey": "MarketSeqNum",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "System Date Time",
    "db_columnname": "System Date Time",
    "datatype": "String",
    "mappingkey": "SystemDateTime",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Customer ID",
    "db_columnname": "Customer ID",
    "datatype": "String",
    "mappingkey": "CustomerID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  }
]